// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__qCqYJ","overviewWrapper":"page_overviewWrapper__vClDR"};